// Copyright ©️ 2026 eVolve MEP, LLC

import { useCallback } from 'react';

import { useEvolvePaginatedGet } from '@evolvemep/api-ts';

export const useCheckIfProjectIdentifierExists = () => {
  const { fetchPage, loading } = useEvolvePaginatedGet('shop/project');

  const checkIfProjectIdentifierExists = useCallback(
    async (projectIdentifier: string) => {
      const { data: projects } = await fetchPage(
        {
          skip: 0,
        },
        {
          params: {
            projectIdentifier,
          },
        },
      );
      return projects.some((p) => p.projectIdentifier?.toLowerCase() === projectIdentifier.toLowerCase());
    },
    [fetchPage],
  );
  return { checkIfProjectIdentifierExists, loading };
};
